module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('div', {
    staticClass: "main-page"
  }, [_vm._h('div', {
    staticClass: "change-role"
  }, [_vm._h('ul', {
    staticClass: "list-group-item tinny"
  }, [_vm._l((_vm.login_data), function(item, index) {
    return _vm._h('li', {
      staticClass: "list-group",
      on: {
        "click": function($event) {
          _vm.selectCurche(index, item)
        }
      }
    }, [_vm._h('div', {
      staticClass: "liner"
    }), " ", (index == _vm.cookie_login_data.index) ? _vm._h('a', {
      staticClass: "group-txt clearfix orange",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._h('span', {
      staticClass: "col-xs-8"
    }, [_vm._s(item.curcheName)]), " ", _vm._h('span', {
      staticClass: "col-xs-4"
    }, [_vm._s(item.jobName)])]) : _vm._h('a', {
      staticClass: "group-txt clearfix",
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._h('span', {
      staticClass: "col-xs-8"
    }, [_vm._s(item.curcheName)]), " ", _vm._h('span', {
      staticClass: "col-xs-4"
    }, [_vm._s(item.jobName)])]), " "])
  })])]), " ", (_vm.isNoRole) ? _vm._h('div', {
    staticClass: "mid-align",
    staticStyle: {
      "width": "100vw"
    }
  }, [_vm._m(1)]) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('a', {
    staticClass: "pull-left img-back",
    attrs: {
      "href": "javascript:window.history.go(-1)"
    }
  }, ["返回"]), " ", _vm._h('h1', ["选择园点及角色"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
},function (){var _vm=this;
  return _vm._h('p', {
    staticClass: "padding-15 margin-15 text-center"
  }, ["\n        亲，您还没有加入任何园点", _vm._h('br'), "快让园长加你为老师吧！\n      "])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-479314b8!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/ChooseRole.vue
// module id = 198
// module chunks = 1